export const cloud = function(ctx: any) {
  ctx.save();
  ctx.strokeStyle = "rgba(0,0,0,0)";
  ctx.miterLimit = 4;  
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(175, 64);
  ctx.bezierCurveTo(175, 55.72, 166.27, 49, 155.5, 49);
  ctx.bezierCurveTo(151.73, 49, 148.23, 49.84, 145.24, 51.26);
  ctx.bezierCurveTo(142.06, 44.72, 133.09, 40, 122.5, 40);
  ctx.bezierCurveTo(118.76, 40, 115.24, 40.6, 112.08, 41.65);
  ctx.bezierCurveTo(106.33, 31.88, 92.68, 25, 76.75, 25);
  ctx.bezierCurveTo(55.63, 25, 38.5, 37.09, 38.5, 52);
  ctx.bezierCurveTo(38.5, 54.38, 38.94, 56.69, 39.76, 58.88);
  ctx.bezierCurveTo(31.15, 60.88, 25, 66.11, 25, 72.25);
  ctx.bezierCurveTo(25, 80.12, 35.07, 86.5, 47.5, 86.5);
  ctx.bezierCurveTo(56.53, 86.5, 64.3, 83.12, 67.88, 78.26);
  ctx.bezierCurveTo(
    70.72999999999999,
    78.74000000000001,
    73.69999999999999,
    79,
    76.75,
    79
  );
  ctx.bezierCurveTo(76.87, 79, 76.98, 78.99, 77.1, 78.99);
  ctx.bezierCurveTo(80.33, 87.67, 90.36, 94, 102.25, 94);
  ctx.bezierCurveTo(109.77, 94, 116.53, 91.46, 121.32, 87.4);
  ctx.bezierCurveTo(
    125.25999999999999,
    90.55000000000001,
    130.72,
    92.5,
    136.75,
    92.5
  );
  ctx.bezierCurveTo(147.2, 92.5, 155.92000000000002, 86.65, 158.01, 78.86);
  ctx.bezierCurveTo(167.59, 77.91, 175, 71.63, 175, 64);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
};
